const CommonPasswords = [
  'password',
  '12345678',
  'baseball',
  'football',
  'jennifer',
  'superman',
  'trustno1',
  'michelle',
  'sunshine',
  '123456789',
  'starwars',
  'computer',
  'corvette',
  'princess',
  'iloveyou',
  'maverick',
  'samantha',
  'steelers',
  'whatever',
  'hardcore',
  'internet',
  'mercedes',
  'bigdaddy',
  'midnight',
  '11111111',
  'marlboro',
  'victoria',
  'butthead',
  'startrek',
  'liverpoo',
  'danielle',
  'redskins',
  'mountain',
  'shithead',
  'xxxxxxxx',
  '88888888',
  'nicholas',
  'metallic',
  'qwertyui',
  'dolphins',
  'cocacola',
  'rush2112',
  'jonathan',
  'scorpion',
  'asdfasdf',
  'godzilla',
  'williams',
  'lifehack',
  'platinum',
  'garfield',
  '69696969',
  'jordan23',
  'bullshit',
  'airborne',
  'elephant',
  'explorer',
  'christin',
  'december',
  'benjamin',
  'dickhead',
  'brooklyn',
  'redwings',
  'michigan',
  '87654321',
  'guinness',
  'einstein',
  'snowball',
  'alexande',
  'passw0rd',
  'lasvegas',
  'slipknot',
  'kimberly',
  '1q2w3e4r',
  'carolina',
  'colorado',
  'creative',
  'bollocks',
  'darkness',
  'asdfghjk',
  'poohbear',
  'nintendo',
  'november',
  'password1',
  'lacrosse',
  'paradise',
  'maryjane',
  'spitfire',
  'anderson',
  'cherokee',
  'drowssap',
  'marshall',
  '1qaz2wsx',
  'caroline',
  'franklin',
  'snickers',
  'courtney',
  'westside',
  'patricia',
  'semperfi',
  'freeuser',
];

export default CommonPasswords;



// WEBPACK FOOTER //
// ./src-react/Validation/CommonPasswords/index.jsx